import React from 'react';
import PropTypes from 'prop-types';
import { Fade } from 'components/Animations';
import styled from 'react-emotion';
import i82 from 'assets/images/i82.svg';
import i83 from 'assets/images/i83.svg';

const propTypes = {
  on: PropTypes.bool,
  large: PropTypes.bool,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  timeout: PropTypes.number,
  style: PropTypes.object,
  fetching: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
  failure: PropTypes.bool.isRequired,
};

const CircleLoader = ({ fetching, absolute, timeout = 200, style, success, failure }) => {
  if(fetching === false && success === false && failure === false) return null;

  return (
    <Fade appear={true} in={true} timeout={timeout} style={style}>
      <CircleLoaderContainer absolute={absolute} success={success} failure={failure} />
    </Fade>
  );
};


const successIcon = <img src={i82} alt="sukces" />;
const failureIcon = <img src={i83} alt="porażka" />;

const CircleLoaderContainer = ({ absolute, success, failure, ...rest }) => {
  const status = failure ? failureIcon :
  success ? successIcon :
  <CircleLoaderInner />;
  return (
    <CircleLoaderWrapper absolute={absolute} {...rest}>
      {status}
    </CircleLoaderWrapper>
  );
}

CircleLoaderContainer.propTypes = {
  absolute: PropTypes.bool,
  success: PropTypes.bool.isRequired,
  failure: PropTypes.bool.isRequired,
};

CircleLoader.propTypes = propTypes;
export default CircleLoader;

const CircleLoaderWrapper = styled('div')`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0px 6px 6px 0px rgba(0,0,0,0.1), 0px 8px 20px rgba(0,0,0,0.09);
  top: 10px;
  right: 10px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.absolute ? `
    position: absolute;
  ` : null}
`;

const CircleLoaderInner = styled('div')`
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 4px solid #673ab7;
  border-radius: 50%;
  animation: spin 0.75s infinite linear;
  display: inline-block;
  border-color: rgba(0, 0, 0, 0.12);
  border-top-color: #673ab7;
  ::before,
  ::after {
    left: -4px;
    top: -4px;
    display: none;
    position: absolute;
    content: '';
    width: inherit;
    height: inherit;
    border: inherit;
    border-radius: inherit;
  }
  ::before {
    display: inline-block;
    border-color: rgba(0, 0, 0, 0.12);
    border-top-color: #673ab7;
    animation: spin 1.5s infinite ease;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/CircleLoader.jsx